import PicturesApp from 'station/components/picture/PicturesApp'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitleWithTownName } from 'utils/StationUtils'

const ProductionUnitPicturesApp = ({

}) => {
    const {
        productionUnit,
        productionUnits,
        citiesIndex,
    } = useSelector(store => ({
        productionUnit: store.ProductionUnitReducer.productionUnit,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const townName = useMemo(() => citiesIndex[productionUnit.townCode]?.name, [citiesIndex, productionUnit])

    useTitle(() => [{
        title: i18n.productionUnit,
        href: 'productionUnit',
    }, {
        title: getStationTitleWithTownName(productionUnit, townName),
        href: `station/productionUnit/${productionUnit?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/productionUnit/${productionUnit?.id}/picture`,
    }], [productionUnit, townName])

    return (
        <PicturesApp
            stations={productionUnits}
            station={productionUnit}
            stationType='productionUnit'
        />
    )
}

export default ProductionUnitPicturesApp